import Reflux from 'reflux';

const RouteActions = Reflux.createActions([
  'goToTeamSignupStep',
  'goToLogin',
  'goToLogout',
  'goToIdentityProviderSSOLogin', //goes to /login/sso/domain, will redirect to the identity provider's login
  'goToSignup',
  'goToTeamDash',
  'goToUserDash',
  'goToTeamTemplates',
  'goToTeamGlobalElements',
  'goToEvent',
  'goToEventCrew',
  'goToShow',
  'goToFeaturedFromTeleprompter',
  'goToTeleprompter',
  'goToRemoteTeleprompter',
  'goToTeleprompterInitialization',
  'goToGrid',
  'goToShowDisplayType',
  'goToShowByTracking',
  'goToGlobalElementManager',
  'goToDisplayView',
  'toggleMobileDisplayMode',
  'goToEventForGuest',
  'goToShowForGuest',
  'goToLearn',
  'logout',
]);

export default RouteActions;
